// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel.attributeTypeMap = [
    {
        "name": "pharmacyId",
        "baseName": "pharmacyId",
        "type": "number"
    },
    {
        "name": "pharmacyName",
        "baseName": "pharmacyName",
        "type": "string"
    },
    {
        "name": "nabp",
        "baseName": "nabp",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "pharmacyType",
        "baseName": "pharmacyType",
        "type": "PharmacyType"
    },
    {
        "name": "pharmacySpecialization",
        "baseName": "pharmacySpecialization",
        "type": "PharmacySpecialization"
    },
    {
        "name": "accountRelationshipIsPrimary",
        "baseName": "accountRelationshipIsPrimary",
        "type": "boolean"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<EnterpriseCoordinatorSharedAddressUpsearchModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<EnterpriseCoordinatorSharedPhoneUpsearchModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<EnterpriseCoordinatorSharedEmailAddressUpsearchModel>"
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": "Array<EnterpriseCoordinatorSharedWebAddressUpsearchModel>"
    },
    {
        "name": "contacts",
        "baseName": "contacts",
        "type": "Array<EnterpriseCoordinatorSharedContactUpsearchModel>"
    },
    {
        "name": "pointOfContacts",
        "baseName": "pointOfContacts",
        "type": "Array<EnterpriseCoordinatorPharmacyServiceModelsPharmacyPointOfContactUpsearchModel>"
    }
];
//# sourceMappingURL=enterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel.js.map